import { Component, HostBinding, NgZone, OnDestroy, OnInit } from "@angular/core";
import { InvalidezStepperService } from "../../service/invalidez-stepper.service";
import { ROUTING_TRAMITE_PENSION } from "@constants/url.constant";
import { NavigationEnd, Router } from "@angular/router";
import { LoadingStateService } from "src/app/tramite-pension/services/loading-state.service";
import { DsStepperComponent } from "@customdesignsystem";
import { CommonModule } from '@angular/common';



@Component({
  selector: "app-pi-stepper",
  templateUrl: "./pi-stepper.component.html",
  styleUrls: ["./pi-stepper.component.scss"],
  standalone: true,
  imports: [DsStepperComponent, CommonModule],
})
export class PiStepperComponent implements OnInit, OnDestroy {
  private static readonly mobileQuery = "(max-width: 1140px)";
  private mediaQuery?: MediaQueryList;
  private readonly onViewportChange = (event: MediaQueryListEvent) => {
    this.ngZone.run(() => {
      this.isResponsive = event.matches;
    });
  };

  step: number = 0;
  isResponsive: boolean = false;
  titleCurrentStepResponsive: string = "";
  currentStepResponsive: string = "";
  isStepperVisible: boolean = true;
  stepperExpanded = false;

  constructor(
    private readonly tramiteStepper: InvalidezStepperService,
    private readonly router: Router,
    private readonly loadingStateService: LoadingStateService,
    private readonly ngZone: NgZone
  ) { }

  @HostBinding("class.responsive")
  get responsive(): boolean {
    return this.isResponsive;
  }

  ngOnInit(): void {
    this.mediaQuery = window.matchMedia(PiStepperComponent.mobileQuery);
    this.isResponsive = this.mediaQuery.matches;
    this.mediaQuery.addEventListener("change", this.onViewportChange);
    this.getCurrentStep();

    // Suscribirse al estado de carga global
    this.loadingStateService.isLoading$.subscribe((isLoading) => {
      this.isStepperVisible = !isLoading;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Verificar si la URL actual es la que quieres redirigir
        if (event.url === '/pensions') {
          this.router.navigate(['/pensions/tramite-pensiones']); // Redirecciona a la ruta base
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.mediaQuery?.removeEventListener("change", this.onViewportChange);
  }

  steps2: any[] = [
    {
      title: 'Datos',
      description: 'Informacion inicial',
      state: 'complete',
      isSelected: false,
      clickable: false
    },
    {
      title: 'Validacion',
      description: 'Validacion del proceso',
      state: 'current',
      isSelected: false,
      clickable: false
    },
    {
      title: 'Revision',
      description: 'Revision final',
      state: 'incoming',
      isSelected: false,
      clickable: false
    },
    {
      title: 'Confirmacion',
      description: 'Confirmacion lista',
      state: 'incoming',
      isSelected: false,
      clickable: false
    }
  ];

  public steps: any[] = [
    {
      state: "current",
      title: "Validación de identidad",
      description: "Confirma tu identidad",
      path: ROUTING_TRAMITE_PENSION.SEGURIDAD,
      url: "/pensions/tramite-pensiones/solicitud/seguridad/keys",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Tu información",
      description: "Revisa tus datos",
      path: ROUTING_TRAMITE_PENSION.DATOS_PERSONALES,
      url: "/pensions/tramite-pensiones/solicitud/datos-personales",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Empleador y licencia médica",
      description: "Valida la información",
      path: ROUTING_TRAMITE_PENSION.VIA_PAGO,
      url: "/pensions/tramite-pensiones/solicitud/via-pago",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Cobertura",
      description: "Detalles de tu cobertura",
      path: ROUTING_TRAMITE_PENSION.VIA_PAGO,
      url: "/pensions/tramite-pensiones/solicitud/via-pago",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Calificación de invalidez",
      description: "Sobre tu enfermedad",
      path: ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS,
      url: "/pensions/tramite-pensiones/solicitud/carga-documentos",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Antecedentes de pensión",
      description: "Responde las preguntas",
      path: ROUTING_TRAMITE_PENSION.CONFIRMAR_DATOS,
      url: "/pensions/tramite-pensiones/solicitud/confirmar-datos",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Información de pagos",
      description: "Elige cómo recibir tu pago",
      path: ROUTING_TRAMITE_PENSION.CONFIRMAR_DATOS,
      url: "/pensions/tramite-pensiones/solicitud/confirmar-datos",
      isSelected: false,
      clickable: false
    },
    {
      state: "incoming",
      title: "Confirmación",
      description: "Envía tu solicitud",
      path: ROUTING_TRAMITE_PENSION.CONFIRMAR_DATOS,
      url: "/pensions/tramite-pensiones/solicitud/confirmar-datos",
      isSelected: false,
      clickable: false
    },
  ];

  getCurrentStep() {
    this.tramiteStepper.stepCurrent.subscribe((response) => {
      this.step = response;
      const totalSteps = this.steps.length;
      this.steps = this.steps.map((step, index) => {
        let state: string;
        if (index + 1 < this.step) {
          state = "complete";
        } else if (index + 1 === this.step) {
          state = "current";
        } else {
          state = "incoming";
        }
        if (state === "current") {
          this.titleCurrentStepResponsive = step.titleResponsive;
          this.currentStepResponsive = `Paso ${index + 1} de ${totalSteps}`;
        }
        return { ...step, state };
      });
    });
  }

  calculateProgress(): number {
    const completedSteps = this.steps.filter(step => step.state === 'current' || step.state === 'complete').length;
    return completedSteps / this.steps.length; // Retorna un valor entre 0 y 1
  }
}
